// JQUERY //
// import $ from "jquery";

// BOOTSTRAP //
import {
	Dropdown,
	Collapse,
	Modal,
	Tab,
	// ScrollSpy,
	Offcanvas
} from "bootstrap";

// Tooltips
import tippy from 'tippy.js';
tippy('[data-tippy-content]');

// IMPORTS //
// import './custom/megamenu';
// import './custom/contain';

// Variabili
let scrollPosition = window.scrollY;
let body = document.querySelector("body");

// Funzioni header
let header = document.querySelector(".header");
let headerH = header.clientHeight;

let pageMenu = document.querySelector(".page-menu");
let pressMenu = document.querySelector(".press-menu");

// Riduce header post scroll
window.onload = function () {
	minifyHeader();
};
window.onscroll = function () {
	minifyHeader();
};

function minifyHeader() {
	if (
		document.body.scrollTop > headerH / 2 ||
		document.documentElement.scrollTop > headerH / 2
	) {
		body.classList.add("minified");
	} else {
		body.classList.remove("minified");
	}
}

// Focus su campo di ricerca
let searchPanel = document.getElementById("search-panel");
if (searchPanel) {
	searchPanel.addEventListener("shown.bs.collapse", function () {
		searchPanel.querySelector(".form-control").focus();
	});
}

// PLUGINS //
// Lazysizes
import lazySizes from "lazysizes";

// Lightbox
import GLightbox from "glightbox";
const lightbox = GLightbox({
	loop: true,
});

// Single Lightbox
const singleLightbox = GLightbox({
	loop: false,
});

const singleLightboxElements = document.querySelectorAll(".glightbox-single");
if (singleLightboxElements) {
	singleLightboxElements.forEach(function (trigger) {
		trigger.addEventListener("click", function (e) {
			e.preventDefault();
			let targetHref = this.getAttribute("href");
			singleLightbox.setElements([
				{
					href: targetHref,
				},
			]);
			singleLightbox.open();
		});
	});
}

// Product Gallery
const productPage = document.querySelector(".page-template-products-single");
if (productPage) {
	if (productsGallery) {
		const productsLightbox = GLightbox({
			loop: true,
			selector: ".gallery-trigger, .gallery-cover",
		});
		productsLightbox.setElements(productsGallery);
	}
}

// Aos
// import AOS from 'aos';
// AOS.init({
//     duration: 200,
//     once: true,
// });

// Smooth Scroll
import SmoothScroll from "smooth-scroll";
import Gumshoe from "gumshoejs";

let scrollHomeVisual = new SmoothScroll(".slide-scroll", {
	updateURL: false,
	popstate: false,
	offset: headerH,
	speed: 1000,
	speedAsDuration: true,
});

let scrollPageMenuHeader = new SmoothScroll(".contact-trigger", {
	updateURL: false,
	popstate: false,
	offset: 72,
	speed: 500,
	speedAsDuration: true,
});

// Page menu
if (pageMenu) {
	// let pageMenuH = pageMenu.clientHeight;
	let scrollPageMenu = new SmoothScroll(".page-menu a.nav-link", {
		updateURL: false,
		popstate: false,
		offset: 72,
		speed: 500,
		speedAsDuration: true,
	});

	const spy = new Gumshoe("#page-menu a", {
		offset: pageMenu.clientHeight,
	});

	// var scrollSpy = new ScrollSpy(document.body, {
	//     target: '#page-menu',
	//     offset: 55,
	// })
}

if (pressMenu) {
	// let pageMenuH = pageMenu.clientHeight;
	let scrollPressMenu = new SmoothScroll(".press-menu a.nav-link", {
		updateURL: false,
		popstate: false,
		offset: 72,
		speed: 500,
		speedAsDuration: true,
	});

	const spy = new Gumshoe("#press-menu a", {
		offset: pressMenu.clientHeight,
	});
}

// Plyr
import Plyr from "plyr";
const yt_player = Plyr.setup(".video-player", {
	controls: [
		"play-large",
		"play",
		"progress",
		"current-time",
		"mute",
		"volume",
		"fullscreen",
	],
	youtube: {
		noCookie: true,
		rel: 0,
		showinfo: 0,
		modestbranding: 1,
	},
	vimeo: {
		byline: false,
		portrait: false,
		title: false,
		speed: true,
		transparent: false,
	},
});

// Swiper
import Swiper, { Navigation, Pagination, Autoplay, Controller, EffectFade } from "swiper";
Swiper.use([Navigation, Pagination, Autoplay, Controller, EffectFade]);

// Homepage Slider
let homepage_slider = new Swiper(".homepage-slider", {
	loop: true,
	spaceBetween: 0,
	allowTouchMove: true,
	speed: 1000,
	autoplay: {
		delay: 7000,
	},
	effect: "fade",
	fadeEffect: {
		crossFade: true,
	},
	navigation: {
		nextEl: ".slide-nav.next",
		prevEl: ".slide-nav.prev",
	},
	pagination: {
		el: ".slider-pagination",
		clickable: true,
	},
});

// Homepage Slider Transitions Start
// homepage_slider.on('slideChangeTransitionStart', function() {
//     let indexSlide = homepage_slider.activeIndex,
//         currentSlide = homepage_slider.slides[indexSlide],
//         animItems = currentSlide.querySelectorAll('[data-aos]');

//     animItems.forEach(function(el) {
//         el.classList.remove('aos-animate');
//         el.classList.remove('aos-init');
//     });
// });

// Homepage Slider Transitions End
// homepage_slider.on('slideChangeTransitionEnd', function() {
//     AOS.refresh({
//         delay: 500,
//     });
// });

// Finiture Slider
let finishSlider = new Swiper(".finish-slider", {
	spaceBetween: 4,
	slidesPerView: 1,
	autoHeight: true,
	loop: true,
	watchOverflow: true,
	speed: 500,
	pagination: false,
	navigation: {
		nextEl: ".finish-nav.next",
		prevEl: ".finish-nav.prev",
	},
	breakpoints: {
		479: {
			slidesPerView: 2,
		},
	},
});

// Gallery Slider
let gallerySlider = new Swiper(".gallery-slider", {
	spaceBetween: 32,
	slidesPerView: 1.5,
	autoHeight: false,
	centeredSlides: true,
	loop: true,
	watchOverflow: true,
	speed: 500,
	pagination: {
		el: ".gallery-pagination",
		type: "bullets",
		clickable: true,
	},
	navigation: {
		nextEl: ".gallery-nav.next",
		prevEl: ".gallery-nav.prev",
	},
});

// Gallery Alt Captions
let galleryCaptionSlider = new Swiper(".gallery-captions", {
	loop: true,
	spaceBetween: 0,
	allowTouchMove: false,
	simulateTouch: false,
	effect: "fade",
	fadeEffect: {
		crossFade: true,
	},
});

// Gallery Alt lider
let galleryAltSlider = new Swiper(".gallery-alt", {
	loop: true,
	spaceBetween: 0,
	allowTouchMove: true,
	effect: "fade",
	fadeEffect: {
		crossFade: true,
	},
	// speed: 1000,
	navigation: {
		nextEl: ".gallery-nav.alt.next",
		prevEl: ".gallery-nav.alt.prev",
	},
	pagination: {
		el: ".gallery-pagination.alt",
		clickable: true,
	},
	controller: {
		control: galleryCaptionSlider,
	},
});

// Gallery in modal
// When the modal is shown, reinitialize the Swiper for the modal gallery
document.addEventListener('shown.bs.modal', function (event) {
	let modalInspireSlider = new Swiper(".modal .inspire-slider", {
		loop: true,
		spaceBetween: 0,
		allowTouchMove: true,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		navigation: {
			nextEl: ".modal .inspire-nav.next",
			prevEl: ".modal .inspire-nav.prev",
		},
	});
});

// Timeline Slider
let timelineSwiper = new Swiper(".timeline-slider", {
	slidesPerView: 1,
	loop: false,
	navigation: {
		nextEl: ".timeline-nav.next",
		prevEl: ".timeline-nav.prev",
	},
});

// Timeline Navigation
function updateYear() {
	let prevLabel = document.querySelector(".prev-year"),
		nextLabel = document.querySelector(".next-year"),
		indexSlide = timelineSwiper.activeIndex,
		prevSlide = timelineSwiper.slides[indexSlide - 1],
		nextSlide = timelineSwiper.slides[indexSlide + 1];

	if (typeof prevSlide !== "undefined") {
		prevLabel.innerHTML = prevSlide.getAttribute("data-year");
	} else {
		prevLabel.innerHTML = "";
	}

	if (typeof nextSlide !== "undefined") {
		nextLabel.innerHTML = nextSlide.getAttribute("data-year");
	} else {
		nextLabel.innerHTML = "";
	}
}

timelineSwiper.on("slideChange", function () {
	updateYear();
});

// Product Header Slider
let productSlider = new Swiper(".product-slider", {
	loop: true,
	spaceBetween: 0,
	allowTouchMove: true,
	effect: "fade",
	fadeEffect: {
		crossFade: true,
	},
	// speed: 1000,
	navigation: {
		nextEl: ".product-nav.next",
		prevEl: ".product-nav.prev",
	},
	pagination: {
		el: ".product-pagination",
		clickable: true,
	},
});

// Blog Gallery Slider
let blogSlider = new Swiper(".blog-slider", {
	slidesPerView: 1,
	autoHeight: false,
	centeredSlides: true,
	loop: true,
	watchOverflow: true,
	speed: 500,
	pagination: {
		el: ".gallery-pagination",
		type: "bullets",
		clickable: true,
	}
});

// Form floater
let formFields = document.querySelectorAll(
	".form-float .form-control, .form-float .form-select"
);

formFields.forEach(function (el) {
	// Imposta placeholder
	el.setAttribute("placeholder", "");
	// Aggiunge classe di BS5
	el.parentNode.classList.add("form-floating");
	// Prende il tag label
	let label = el.parentNode.parentNode.querySelector("label");
	// Sposta label nello stesso nodo dell'input
	el.parentNode.append(label);
});

// Accordion repositioner
const accordionItems = document.querySelectorAll(".accordion-collapse");
const accordionWrapper = document.querySelector(".accordion");

accordionItems.forEach((el) => {
	el.addEventListener("shown.bs.collapse", (e) => {
		scrollToAccordionItem(el);
	});

	el.addEventListener("hidden.bs.collapse", (e) => {
		scrollToAccordionItem(el);
	});
});

function scrollToAccordionItem(el) {
	let headerHeight = document.querySelector(".header").clientHeight;
	let scrollOffset =
		accordionWrapper.scrollTop + el.parentNode.offsetTop - headerHeight;
	
	window.scroll({
		top: scrollOffset,
		left: 0,
		behavior: "smooth",
	});
}


// Select all contact buttons
let contactButtons = document.querySelectorAll('.contact-btn');

// Check if there are any buttons
if (contactButtons.length > 0) {
	contactButtons.forEach(function (contactBtn) {
		contactBtn.addEventListener('click', function (event) {
			event.preventDefault();  // Prevent default anchor behavior

			// Close all modals
			let modals = document.querySelectorAll('.modal.show');
			modals.forEach(function (modal) {
				let modalInstance = Modal.getInstance(modal);
				if (modalInstance) {
					modalInstance.hide();
				}
			});

			// Get the target from the data-target attribute
			let target = this.getAttribute('data-target');
			let scroll = new SmoothScroll();
			scroll.animateScroll(document.querySelector(target), null, {
				offset: headerH,  // Adjust this value based on your header height or other offsets
				speed: 1000,  // Speed for the scroll
				speedAsDuration: true,
				updateURL: false,
				popstate: false,
			});

			// Set form value
			let form = document.querySelector('#contact-form form')
			let inspireValue = this.getAttribute('data-item');
			let originField = form.querySelector('[name="inspire"]');
			if (originField) {
				originField.value = inspireValue;  // Set the value to the field
			}
			let inspireImg = this.getAttribute('data-image');
			let imgField = form.querySelector('[name="image"]');
			if (imgField) {
				imgField.value = inspireImg;  // Set the value to the field
			}
		});
	});
}


// BIZEN
document.addEventListener("DOMContentLoaded", function () {
	console.log(
		"A DIGITAL PROJECT BY\n\r······································································································\n\r·oooo·································································································\n\r·oooo·································································································\n\r·oooo······················oooo·······································································\n\r·oooo·································································································\n\r·oooo·································································································\n\r·oooo····oooooo············oooo······oooooooooooooooo·········ooooooooo···············oooooooooo······\n\r·oooooooooooooooooo········oooo·····ooooooooooooooooo······ooooooooooooooo·········oooooooooooooooo···\n\r·oooooooo······ooooo·······oooo················ooooo·····ooooo·········ooooo·····ooooo··········ooooo·\n\r·ooooo···········ooooo·····oooo··············ooooo······ooooo···········ooooo····ooo·············oooo·\n\r·oooo·············oooo·····oooo·············ooooo·······ooooooooooooooooooooo···oooo··············ooo·\n\r·oooo·············oooo·····oooo···········ooooo·········oooo····················oooo··············ooo·\n\r·oooo·············oooo·····oooo··········oooo···········oooo····················oooo··············ooo·\n\r··ooooo·········ooooo······oooo········ooooo·············oooo···········oooo····oooo··············ooo·\n\r····oooooooooooooooo·······oooo······ooooooooooooooo······oooooo······ooooo·····oooo··············ooo·\n\r·······oooooooooo··········oooo·····ooooooooooooooooo········oooooooooooo·······oooo··············ooo·\n\r······································································································\n\r"
	);
});

// MEGAMENU
const megamenus = document.querySelectorAll("[data-megamenu]");

if (megamenus) {
	function initTab(elem) {
		document.addEventListener("mouseover", function (e) {
			if (!e.target.matches(elem + " .m-trigger")) return;
			else {
				if (!e.target.classList.contains("m-active")) {
					findActiveElementAndRemoveIt(elem + " .m-trigger");
					findActiveElementAndRemoveIt(elem + " .m-panel");
					e.target.classList.add("m-active");
					let panel = document.querySelectorAll(
						elem + " .m-panel#" + e.target.dataset.name
					);
					Array.prototype.forEach.call(panel, function (el) {
						el.classList.add("m-active");
					});
				}
			}
		});
	}

	function findActiveElementAndRemoveIt(elem) {
		let elementList = document.querySelectorAll(elem);
		Array.prototype.forEach.call(elementList, function (e) {
			e.classList.remove("m-active");
		});
	}

	megamenus.forEach(function (el) {
		let megaID = el.getAttribute("data-megamenu");
		// console.log(megaID);
		initTab("[data-megamenu=" + megaID + "]");
	});

	// Subchild previews
	let subTriggers = document.querySelectorAll(".subtrigger");
	let preview = document.querySelector(".m-preview");
	let subPreviews = document.querySelectorAll(".m-subpreview");

	subTriggers.forEach(function (el) {
		el.addEventListener("mouseover", function () {
			let childID = el.getAttribute("data-id");
			let currentPreview = document.querySelector(
				'.m-subpreview[data-id="' + childID + '"]'
			);
			//console.log(childID);
			//console.log(currentPreview);
			currentPreview.classList.add("active");
		});
		el.addEventListener("mouseout", function () {
			subPreviews.forEach(function (sp) {
				sp.classList.remove("active");
			});
		});
	});
}
